<template>
  <ApolloMutation
    :mutation="(gql) => updateChapterTextMutation"
    :variables="{
      chapterId: chapterIri,
      text: text,
    }"
    @loading="loading => { syncing = loading; startSyncingTimer() } "
    @error="setError"
    :update="updated"
 ref="mutation"
  >
    <template v-slot="{ }">
            <v-hover
        v-slot="{ hover }"
      >
          <v-btn min-width="13rem"
            :color="!error || (error && hover) ? 'secondaryAction' : 'error'"
            class="save-button"
            :class="shake ? 'shake' : ''"
            @click="save"
            :disabled="showSaving"
          ><img width="24px" :src="error && hover ? cloud_retry : icon " /> &nbsp; {{ error && hover ? $t('forms.retrySave') : buttonText }}</v-btn>
            </v-hover>
          <v-slide-y-transition>
            <div v-show="error" style="font-size: 0.8rem;" class="error-text">{{ $t('forms.areYouOffline') }}</div>
          </v-slide-y-transition>
    </template>
  </ApolloMutation>
</template>
<script>
import { chapterQueries } from "@/graphql/ChapterQueries";
import debounce from "@/helpers/debounce";
import cloud_done from "@/assets/icons/cloud_done.svg";
import cloud_pending from "@/assets/icons/cloud_pending.svg";
import cloud_error from "@/assets/icons/cloud_error.svg";
import cloud_saving from "@/assets/icons/cloud_saving.svg";
import cloud_retry from "@/assets/icons/cloud_retry.svg";
export default {
  props: {
    text: String,
    chapterIri: String,
  },
  data() {
    return { 
      unsavedChanges: false,
      syncing: false,
      error: false,
      syncingPadtimeDone: true,
      shake: false,
      doNotNotifyOfError: false,
    }
  },
  methods: {
    debouncedSave: debounce(function () {
      this.save()
    }, 1000),
    save() {
      this.error = false
      this.$refs.mutation.mutate()
    },
    updated() {
      this.error = false
      this.unsavedChanges = false
      this.doNotNotifyOfError = false
    },
    setError() {
      this.error = true
    },
    startSyncingTimer() {
      this.syncingPadtimeDone = false
      setTimeout(() => { this.syncingPadtimeDone = true}, 1000)
    },
    shakeButton() {
      this.shake = true
      setTimeout(() => { this.shake = false}, 1000)
    },
  },
  watch: {
    error(newValue) {
      if (!newValue || !this.doNotNotifyOfError) { 
        this.$emit('error', newValue)
      }
      setTimeout(() => { if (this.error) { this.save(); this.doNotNotifyOfError = true } }, 30000)
    },
    text() {
      this.unsavedChanges = true
      this.debouncedSave()
    },
    syncing(newValue) {
      this.$emit('syncing', newValue)
    },
    unsavedChanges(newValue) {
      this.$emit('unsavedChanges', newValue)
    }
  },
  computed: {
    cloud_retry() {
      return cloud_retry
    },
    showSaving() {
      return this.syncing || !this.syncingPadtimeDone
    },
    updateChapterTextMutation() {
      return chapterQueries.updateChapterText
    },
    icon () {
      if (this.error) {
        return cloud_error 
      }
      if (this.showSaving) {
        return cloud_saving
      }
      if (this.unsavedChanges) {
        return cloud_pending
      }
      return cloud_done
    },
    buttonText() {
      if (this.error) {
        return this.$t('forms.saveFailed')
      }
      if (this.showSaving) {
        return this.$t('forms.saving')
      }
      if (this.unsavedChanges) {
        return this.$t('forms.unsavedChanges')
      }
      return this.$t('forms.changesSaved')
    }
  },
}
</script>
<style lang="scss" scoped>
button.v-btn.v-btn--has-bg.v-btn--disabled.save-button {
    background-color: var(--v-secondaryAction-base) !important;
    color: white !important;
}
button.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>